export default "__VITE_ASSET__CQM2Ddxc__"